<div *ngIf="isLoggedIn">
	<header [title]="title" (reloadPage)="reloadPage()"></header>

	<content [ngClass]="{ 'no-footer': !showFooter }">
		<p class="breadcrumb-inline">
			<span class="crumb home" [class.active]="isHomeRoute" (click)="navigateTo('/')">Home</span>
			<ng-container *ngIf="isHierarchyRunRoute">
				<span class="crumb-separator">&gt;</span>
				<span class="crumb run-link" (click)="navigateToRefineryFromBreadcrumb()">{{ breadcrumbRefineryLabel }}</span>
				<span class="crumb-separator">&gt;</span>
				<span class="crumb run-link" (click)="navigateToUnitFromBreadcrumb()">{{ breadcrumbUnitLabel }}</span>
				<span class="crumb-separator">&gt;</span>
				<span class="crumb current active">{{ breadcrumbHierarchyRunLabel }}</span>
			</ng-container>
			<ng-container *ngIf="!isHierarchyRunRoute && isHierarchyUnitRoute">
				<span class="crumb-separator">&gt;</span>
				<span class="crumb run-link" (click)="navigateToRefineryFromBreadcrumb()">{{ breadcrumbRefineryLabel }}</span>
				<span class="crumb-separator">&gt;</span>
				<span class="crumb current active">{{ breadcrumbUnitLabel }}</span>
			</ng-container>
			<ng-container *ngIf="!isHierarchyRunRoute && !isHierarchyUnitRoute && isHierarchyRefineryRoute">
				<span class="crumb-separator">&gt;</span>
				<span class="crumb current active">{{ breadcrumbRefineryLabel }}</span>
			</ng-container>
			<ng-container *ngIf="isRunCitationsGuideRoute">
				<span class="crumb-separator">&gt;</span>
				<span class="crumb run-link" (click)="navigateToRunFromBreadcrumb()">{{ breadcrumbRunLabel }}</span>
				<span class="crumb-separator">&gt;</span>
				<span class="crumb run-link" (click)="navigateToCitationsFromBreadcrumb()">{{ breadcrumbCitationAssetLabel }}</span>
				<span class="crumb-separator">&gt;</span>
				<span class="crumb current active">Guide</span>
			</ng-container>
			<ng-container *ngIf="isRunGuideRoute || isRunCitationsRoute">
				<span class="crumb-separator">&gt;</span>
				<span class="crumb run-link" (click)="navigateToRunFromBreadcrumb()">{{ breadcrumbRunLabel }}</span>
				<span class="crumb-separator">&gt;</span>
				<span class="crumb current active">{{ currentBreadcrumbLabel }}</span>
			</ng-container>
			<ng-container *ngIf="!isHierarchyRefineryRoute && !isHierarchyUnitRoute && !isHierarchyRunRoute && !isRunGuideRoute && !isRunCitationsRoute && !isRunCitationsGuideRoute && currentBreadcrumbLabel !== ''">
				<span class="crumb-separator">&gt;</span>
				<span class="crumb current" [class.active]="!isHomeRoute">{{ currentBreadcrumbLabel }}</span>
			</ng-container>
		</p>
		<div class="content-body">
			<router-outlet></router-outlet>
		</div>
	</content>

	<footer *ngIf="showFooter"></footer>
</div>

<div *ngIf="modal" class="modal-window">
	<div class="locked"></div>
	<ng-container [ngComponentOutlet]="modal.type" [ndcDynamicInputs]="modal.inputs" [ndcDynamicOutputs]="modal.outputs"></ng-container>
</div>

<div *ngIf="!isLoggedIn && layoutCssClass !== 'noaccess'">
    <div class="auth">Authenticating...</div>
</div>

<access *ngIf="layoutCssClass === 'noaccess'"></access>
<error *ngIf="error !== ''" [message]="error"></error>

<div *ngIf="showAlert" class="modal-window">
	<div class="locked"></div>
	<alert
		[title]="alertTitle"
		[message]="alertMessage"
		[continueText]="alertContinueText"
		[cancelText]="alertCancelText"
		(continueEvent)="alertContinue()"
		(cancelEvent)="alertCancel()"></alert>
</div>

<sdk-loading [isLoading]="isLoading"></sdk-loading>
